import { Mesh } from "three";
function disposeMaterial(material) {
    if (material.map)
        material.map.dispose();
    if (material.lightMap)
        material.lightMap.dispose();
    if (material.bumpMap)
        material.bumpMap.dispose();
    if (material.normalMap)
        material.normalMap.dispose();
    if (material.specularMap)
        material.specularMap.dispose();
    if (material.envMap)
        material.envMap.dispose();
    if (material.aoMap)
        material.aoMap.dispose();
    if (material.metalnessMap)
        material.metalnessMap.dispose();
    if (material.roughnessMap)
        material.roughnessMap.dispose();
    if (material.emissiveMap)
        material.emissiveMap.dispose();
    material.dispose();
}
export function disposeMesh(mesh) {
    if (!(mesh instanceof Mesh))
        return;
    if (mesh.geometry) {
        mesh.geometry.dispose();
    }
    if (mesh.material) {
        if (Array.isArray(mesh.material)) {
            for (const mat of mesh.material) {
                disposeMaterial(mat);
            }
        }
        else {
            disposeMaterial(mesh.material);
        }
    }
}
